import React, { Suspense, useState, useEffect } from "react";
import Drawer from 'react-modern-drawer';
import projectServices from "./projectServices";
import NewClassList from "./newClassList";
import Pagination from "../Header/Pagination";

export default function ClassListing (param:any) {

    let [totalRow, inittotalRow] = useState(0);
    let [SearchText , setSearchText] = useState("");
    let [ReleaseISRC , setReleaseISRC] = useState("");
    let [addClassList, initaddClassList] = useState(false);
    let [classlistListing, initclasslistListing] = useState<any[]>([]);    

    const closeClassListing = (e: any) => {
        param.closeClassListing(e);
    }

    useEffect(() => { 
        apiCall();
    }, [param.open]);

    var classListPayload ={
        ReleaseISRC : ReleaseISRC ,
        SearchText: SearchText ,
        pageNumber: 1,
        pageSize: 10
    }

    const apiCall =()=>{

        projectServices.classlistListing(classListPayload).then((res)=>{
            initclasslistListing(res);
            inittotalRow(res && res[0] && res[0].totalRows ?res[0].totalRows : 0 )
        })
    }

    const selectMPMCLassList =(e:any)=>{
        console.log(e)
        closeClassListing(e)
    }

    const onchangeCloseClassList =(e:any)=>{
        if(e=="close"){
            initaddClassList(false)
        }
        apiCall();
    }    

    const handleNameOnChange = (n: any) => {  
        classListPayload.pageNumber = n.pageNumber;
        classListPayload.pageSize = n.pageSize; 
        apiCall()  
    }

    return (
        <>
        <Drawer 
            open={param.open} onClose={() =>closeClassListing("close")}                 
            direction='right'
            className='react-drawer-left full-height-vh allowHscroll' style={{ width: "100%" }}>

            <div className="ws-8 box pull-right box" style={{ height: "100%" }}>                 

                <div className="row-fluid box-header-fix">
                    <div className="box">
                        <div className="box-header-main"><i className="fa fa-search"></i> Search</div>

                        <div className="box-content"> 
                            <div className="row-fluid">

                                <div className="form-format ws-7">
                                    <label >ReleaseISRC</label>

                                    <div className="label-entries">
                                        <input type="text" id="ReleaseISRC" value={ReleaseISRC} onChange={(e:any)=>setReleaseISRC(e.target.value)} placeholder="Enter releaseISRC" maxLength={50} />
                                    </div>
                                </div>

                                <div className="form-format ws-7">
                                    <label>Search Text</label>
                                    <div className="label-entries">
                                        <input type="text" id="SearchText" value={SearchText} onChange={(e:any)=>setSearchText(e.target.value)} placeholder="Enter searchText" maxLength={75} />
                                    </div>
                                </div>
                            </div>                            
                        </div>

                        <div className="box-footer">
                            <a className="icon-btn edit" onClick={apiCall}> Search <i className="icon-search"></i>  </a>
                            <a className="icon-btn edit" onClick={()=>initaddClassList(true)}> <i className="fa fa-plus-circle"></i> Add Class List </a>
                        </div>
                    </div>

                    <div className="box span12 m0" ng-show="classListItems">

                        <div className="box-header well">
                            <h2 ><i className="fa fa-list-alt"></i> Class List - {totalRow} record(s) found</h2>
                        </div>

                        <div className="box-content">
                            <div className="table-responsive_big">
                                {(totalRow === 0) && <div className="alert alert-info"> No class list found</div>}
                                
                                {(totalRow > 0) &&<table className="newTable">
                                    <thead>
                                        <tr>
                                            <th>ReleaseISRC</th>
                                            <th>ClassList</th>
                                            <th>ReleaseAlt1</th>
                                            <th>ReleaseAlt2</th>
                                            <th>ReleaseAlt3</th>
                                            <th>ReleaseAlt4</th>
                                            <th>ReleaseAlt5</th>
                                            <th>ReleaseAlt6</th>
                                            <th>Operation</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {classlistListing?.map((value:any)=>{
                                            
                                            return(
                                            <tr ng-repeat="(indexClassListItem, classListItem) in classListItems" >
                                                <td >{value.releaseISRC}</td>
                                                <td >{value.classList}</td>
                                                <td >{value.releaseAlt1}</td>
                                                <td >{value.releaseAlt2}</td>
                                                <td >{value.releaseAlt3}</td>
                                                <td >{value.releaseAlt4}</td>
                                                <td >{value.releaseAlt5}</td>
                                                <td >{value.releaseAlt6}</td>
                                                <td >
                                                    <button type="button" className="icon-btn info btn-sm" onClick={()=>selectMPMCLassList(value)}> Select </button>
                                                </td>
                                            </tr> )
                                    })}
                                    </tbody>
                                </table>}

                                <div className="clearfix"> 
                                {     
                                    (() => {
                                        if(totalRow>0 && totalRow>10){
                                            return <Pagination onChange={handleNameOnChange} totalRows={totalRow} />
                                        }
                                                                        
                                    })()
                                }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="box-footer">
                    <button className="icon-btn delete btn-sm" onClick={()=>closeClassListing("close")}>
                        <i className="fa fa-close"></i> Close
                    </button>
                </div>
            </div>

        </Drawer>
        
        {(() => {
            if (addClassList) {
                return <NewClassList open={addClassList}  onchangeCloseClassList={onchangeCloseClassList}/>
            } 
        })()}
        </>
    )
}